import { Typography, Grid, List } from "@mui/material";
import React from "react";
import { FormWrapper } from "../../../components/formWrapper";
import { InterestOptionItem } from "../step4/interestOptionItem";
import { getDtoFromStep4FormValues } from "../step4/helper";
import { QueuedUpdateContext } from "../queuedUpdateContext/context";
import { TagManagerService } from "services/tagManager";
import { EnumGTMEvents } from "services/tagManager/enums/enumGTMEvents";
import { EnumCajuInterest } from "services/caju/enums/enumCajuInterest";
import { LeadService } from "services/caju";

interface StepPMERouteProps {
  name?: string;
  externalId: string;
  onSalesTouch: () => void;
  buildRegisterLink: () => string;
}

export function StepPMERoute(props: StepPMERouteProps) {
  const queueContext = React.useContext(QueuedUpdateContext);

  const getFirstName = (name?: string) => name?.split(" ")[0];

  const handleHire = () => {
    TagManagerService.push(
      EnumGTMEvents.INTEREST_INFO_INTEREST_OPTION_SIGNUP_NOW__CLICK,
    );

    const data = getDtoFromStep4FormValues(
      props.externalId,
      EnumCajuInterest.HIRE,
      queueContext.id,
    );
    const registerUrl = props.buildRegisterLink();

    queueContext.push(data, LeadService.saveLead, () =>
      window.open(registerUrl, "_self", "noopener noreferrer"),
    );
  };

  const handleTalkToConsultant = () => {
    TagManagerService.push(
      EnumGTMEvents.INTEREST_INFO_INTEREST_OPTION_SCHEDUALED_MEETING__CLICK,
    );

    const data = getDtoFromStep4FormValues(
      props.externalId,
      EnumCajuInterest.TALK_TO_CONSULTANT,
      queueContext.id,
    );

    queueContext.push(data, LeadService.saveLead, () => props.onSalesTouch());
  };

  return (
    <FormWrapper>
      <Grid container>
        <Grid item xs={12} md={7} sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              "&:first-letter": { textTransform: "capitalize" }
            }}
          >
            {getFirstName(props.name)}, como você prefere continuar?
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <form data-cy="step-pme-route-form">
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <InterestOptionItem
                title="Quero contratar por conta própria"
                description="Faça seu cadastro agora e siga a contratação no seu ritmo."
                onClick={handleHire}
                disabled={queueContext.loading}
              />

              <InterestOptionItem
                title="Quero falar com um consultor"
                description="Receba atendimento consultivo para ajudar na contratação."
                onClick={handleTalkToConsultant}
                disabled={queueContext.loading}
              />
            </List>
          </form>
        </Grid>
      </Grid>
    </FormWrapper>
  );
}
